



















































































































import {Vue, Component, Watch} from 'vue-property-decorator';
import Zone from '@/models/zone';
import Paginition from '@/components/Paginition.vue';
import FilterMenu from '@/components/FilterMenu.vue';
import {Filter} from '@/utils/Filter';
import {Utils} from '@/utils/Utils';
import {mapActions} from 'vuex';
import {API} from '@/services/api/api';

@Component({
  methods: {...mapActions(['showSuccessToast', 'showErrorToast'])},

  components: {
    Paginition,
    FilterMenu,
  },
})
export default class ZoneList extends Vue {
  header = [
    {
      value: 'shipName',
      name: 'Ship Name',
      headerType: 'text',
      asdcOrder: true,
      filter: true,
      sortable: true,
    },
    {
      value: 'deckName',
      name: 'Deck',
      headerType: 'text',
      asdcOrder: true,
      filter: true,
      sortable: true,
      bindClass: 'shortDiv',
    },
    {
      value: 'zoneName',
      name: 'Zone',
      headerType: 'text',
      asdcOrder: true,
      filter: true,
      sortable: true,
    },
    {
      value: 'zoneStartPoint',
      name: 'Start Point Of Zone',
      headerType: 'number',
      asdcOrder: true,
      filter: true,
      sortable: true,
    },
    {
      value: 'zoneEndPoint',
      name: 'End Point Of Zone',
      headerType: 'number',
      asdcOrder: true,
      filter: true,
      sortable: true,
    },
    {
      value: 'remarks',
      name: 'Comments',
      headerType: 'text',
      asdcOrder: true,
      filter: true,
      sortable: true,
    },
    {
      value: 'isActive',
      name: 'Status',
      headerType: 'text',
      filter: false,
      sortable: false,
      bindClass: 'text-center shortDiv',
    },
    {
      value: 'createdDate',
      name: 'Created',
      headerType: 'date',
      asdcOrder: true,
      filter: true,
      sortable: true,
    },
    {
      value: 'edit',
      name: 'Edit',
      headerType: 'text',
      filter: false,
      sortable: false,
      bindClass: 'text-center edit',
    },
    {
      value: 'delete',
      name: 'Delete',
      headerType: 'text',
      filter: false,
      sortable: false,
      bindClass: 'text-center delete',
    },
  ];

  startingPoint = 0; //pagination starting point
  endingPoint = 5; //pagination ending point
  curentSort = ''; //current sort on which header
  numberOfRows = 5;
  //Store Variable
  showSuccessToast: any;
  showErrorToast: any;

  //Modal & Loader Variable
  isScreenLoading = false;
  modalVisible = false;
  loadingBtnStatus = false;
  modalConfimationMsg: any = null;
  modalTitle: any = null;

  zoneId: any = null;
  deleteStatus: any = null;
  asdcOrder = true;

  // filtertedZoneList: Zone[][];
  // zoneList = [];

  modifyZoneList: Zone[] = [];
  modifiedFilteredZoneList: Zone[] = [];

  zoneDeckId: string | null = null;

  mounted() {
    this.getZoneList();
  }

  async getZoneList() {
    this.isScreenLoading = true;

    try {
      const response = await API.fetchZoneList();

      if (response.data) {
        let zones = response.data;

        this.modifyArray(zones);
      } else {
        this.isScreenLoading = false;
        this.modifiedFilteredZoneList = [];
        this.showErrorToast({msg: response.error});
      }
    } catch (error) {
      this.showErrorToast({msg: 'Network error'});
      this.isScreenLoading = false;
    }
  }

  modifyArray(zoneData: any) {
    this.modifiedFilteredZoneList = [];
    this.modifyZoneList = [];
    zoneData.map((obj) => {
      const zonemaster = obj.zoneMasters.map((obj2) => ({
        ...obj2,
        deckName: obj.drawing.name,
        shipName: obj.drawing.ship.name,
      }));
      this.modifyZoneList = [...this.modifyZoneList, ...zonemaster];
    });

    this.modifiedFilteredZoneList = this.modifyZoneList;
    this.isScreenLoading = false;
  }

  //pagination value listener show data based on pagination
  onPaginitionValueChange(startingPoint: number, endingPoint: number, records: number) {
    this.numberOfRows = records;
    this.startingPoint = startingPoint - 1;
    this.endingPoint = endingPoint;
  }

  //sorting list
  clickOnSort(header: any) {
    if (this.curentSort !== header.value) {
      this.curentSort = header.value;
      this.asdcOrder = true;
    }
    let sorted = Utils.sortData(this.asdcOrder, header, this.modifiedFilteredZoneList);
    this.asdcOrder = sorted;
  }

  filterOnText(emittedFilterParams: any) {
    let filteredData = Filter.filterOnTextData(emittedFilterParams, this.modifyZoneList);
    this.modifiedFilteredZoneList = filteredData;
    this.resetPagination();
  }

  filterOnNumber(emittedFilterParams: any) {
    let filteredData = Filter.filterOnNumberData(emittedFilterParams, this.modifyZoneList);

    this.modifiedFilteredZoneList = filteredData;
    this.resetPagination();
  }

  //filter data based upon date parameters
  filterOnDate(emittedFilterParams: any) {
    let filteredData = Filter.filterOnDateData(emittedFilterParams, this.modifyZoneList);
    this.modifiedFilteredZoneList = filteredData;
    this.resetPagination();
  }

  formatDate(originalDate: string | Date) {
    let formattedDate = Utils.formatDate(originalDate);
    return formattedDate;
  }

  //reset all filters and show current list of data
  resetFilter(isDefaultList: boolean) {
    if (isDefaultList) {
      this.modifiedFilteredZoneList = this.modifyZoneList;
      this.resetPagination();
    }
  }

  //reset pagination to first page
  resetPagination() {
    const pagination: any = this.$refs.pagination;
    setTimeout(() => {
      pagination.reset();
    }, 150);
  }

  //show activate/deactivate  confirmation  modal
  displayStatusModal(recordId: string, recordEnableStatus: boolean) {
    this.zoneDeckId = recordId;
    let msg;
    if (recordEnableStatus) {
      msg = 'Deactivate';
    } else {
      msg = 'Activate';
    }
    this.modalVisible = true;
    this.modalTitle = `${msg} Confirmation`;
    msg = msg.toLowerCase();
    this.modalConfimationMsg = `Are you sure want to ${msg} ?`;
    this.deleteStatus = false;
  }

  //show delete confirmation  modal
  displayDeleteModal(recordId: string) {
    this.zoneDeckId = recordId;
    this.modalVisible = true;
    this.modalTitle = 'Delete Confirmation';
    this.modalConfimationMsg = 'Are you sure want to delete ? It will also remove all frames of this zone.';
    this.deleteStatus = true;
  }

  public editZone(zoneId: string) {
    this.$router.push({path: '/edit-zone/' + zoneId});
  }

  //call delete or activate/deactivate method based upon confirmation
  async deleteOrChangeStatus() {
    try {
      const response = this.deleteStatus
        ? await this.deleteZone(this.zoneDeckId)
        : await this.changeStatus(this.zoneDeckId);

      const message = this.deleteStatus ? 'Record deleted successfully' : 'Record updated successfully';

      if (response) {
        this.showSuccessToast({msg: response.message});
        if (this.deleteStatus) {
          this.modifiedFilteredZoneList = this.modifiedFilteredZoneList.filter(
            (zone) => zone.zoneDeckId != this.zoneDeckId
          );
          this.modifyZoneList = this.modifyZoneList.filter((zone) => zone.zoneDeckId != this.zoneDeckId);
        } else {
          this.getZoneList();
        }
      } else {
        this.showErrorToast({msg: response.error});
      }
    } catch (error) {
      this.showErrorToast({msg: 'Network error'});
    }
  }

  async deleteZone(zoneID) {
    return await API.deleteZoneById(zoneID);
  }

  async changeStatus(zoneDeckId: string) {
    const zone = this.modifyZoneList.find((me) => me.zoneDeckId === zoneDeckId);
    return await API.changeZoneDeckStatus(zoneDeckId, !zone.isActive);
  }
}
